export default function unsupportedProp(props, propName, componentName, location, propFullName) {
    if ("production" === 'production') {
        return null;
    }
    const propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== 'undefined') {
        return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
    }
    return null;
}
